<script lang="ts">
	import ConfirmModal from '$lib/components/Modal/ConfirmModal.svelte';
	import { _ } from 'svelte-i18n';
	import { getHubStores } from '$lib/stores/hubStores';
	import { toastMessages } from '$lib/stores/toastMessageStore';
	import { showLogoutStore } from '$lib/stores/sessionExpire';

	export let expirationDuration: string;

	const { api, hub } = getHubStores();
	let isSessionEndWarningModalOpen = true;

	const refreshSession = async () => {
		try {
			await api.refreshSession({ hubId: $hub.id });
			showLogoutStore.set($hub.settings.cookie_max_age);
			isSessionEndWarningModalOpen = false;
			toastMessages.success($_('hub.settings.user.session.warning.extend.success'));
		} catch (e) {
			toastMessages.danger($_('common.error.wrong'), e);
		}
	};
</script>

<ConfirmModal
	content={$_('hub.settings.user.session.warning', {
		values: { minutes: expirationDuration },
	})}
	submitText={$_('hub.settings.user.session.warning.extend')}
	onCancel={() => {
		isSessionEndWarningModalOpen = false;
	}}
	onSubmit={refreshSession}
	isOpen={isSessionEndWarningModalOpen}
/>
